import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=53262951&"
import script from "./NavbarComponent.vue?vue&type=script&lang=js&"
export * from "./NavbarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports